import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { webhookEventsMessages } from 'src/features/webhook-events/utils/messages';
import WebhookEventsTable from 'src/features/webhook-events/components/tables/WebhookEventsTable';

const WebhookEventsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(webhookEventsMessages.webhookEvents));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <WebhookEventsTable />;
};

export default WebhookEventsLayout;
